import '../css/index.scss'
import {handleEvents} from "./events";
import {initDefaultSelect2} from "./select2";
import {disableConsoleLogs} from "./utils";
import {initI18Next} from "./i18next";
import {initCreemSubscriptionModal} from "./creem-subscription-modal";
import {initSearchControls} from "./search-control";
import {initFileDeleteModal} from "./file-delete-modal";
import {initInAppBell} from "../../notifications/js/bell";
import {initInAppPopupPreview, initInAppPopups} from "../../notifications/js/popup-trigger";
import {initSiteBanner} from "./site-banner";


$(document).ready(function () {
    //disableConsoleLogs()
    initSiteBanner()
    window.__commonI18nReady = initI18Next(['common', 'billing'])
    initCreemSubscriptionModal(window.__commonI18nReady)
    initSearchControls()
    handleEvents()
    initDefaultSelect2()
    initFileDeleteModal()
    const bell = initInAppBell(window.__commonI18nReady)
    initInAppPopups(bell?.firstCount, window.__commonI18nReady)
    initInAppPopupPreview(window.__commonI18nReady)

})
